<template>
  <div>
    <Transition name="loading">
      <Loading v-if="storeUtils.isLoading" />
    </Transition>
    <metainfo>
      <template v-slot:title="{ content }">{{
        content
          ? `${content} | UniBridge`
          : `UniBridge | Asia preferred rental NFT platform | Rent to earn`
      }}</template>
    </metainfo>
    <header />
    <RouterView />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useUtilsStore } from '@/store/storeUtils';
import Loading from '@/components/share/loading.vue';
import Moralis from 'moralis';
import { useMeta } from 'vue-meta';
import router from '@/router';

useMeta({
  title: '',
  description: `UniBridge | Asia preferred rental NFT platform | Rent to earn`,
  meta: [
    {
      property: 'og:title',
      content: `UniBridge | Asia preferred rental NFT platform | Rent to earn`,
    },
    {
      property: 'og:description',
      content: `UniBridge | Asia preferred rental NFT platform | Rent to earn`,
    },
    {
      property: 'og:image',
      content:
        'https://s3.ap-northeast-1.amazonaws.com/unibridge.io/UniBridgeBanner.png',
    },
    {
      property: 'og:url',
      content:
        process.env.VUE_APP_BASE_URL + router.currentRoute.value.fullPath,
    },
  ],
});
const storeUtils = useUtilsStore();
onMounted(async () => {
  storeUtils.checkDevice();
});
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.loading-enter-active,
.loading-leave-active {
  transition: opacity 0.5s ease;
}

.loading-enter-from,
.loading-leave-to {
  opacity: 0;
}
</style>
